import { render, staticRenderFns } from "./ApfPreSupportingDocument.vue?vue&type=template&id=5ce8a9f0"
import script from "./ApfPreSupportingDocument.vue?vue&type=script&lang=js"
export * from "./ApfPreSupportingDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports